if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
  document.fonts.ready.then(async () => {
    let carMaxSharpSansDispBold = new FontFace(
      'CarMaxSharpSansDisp-Bold',
      'url(https://www.carmax.com/shared/fonts/CarMaxSharpSansDisp-Bold.woff2)',
      { style: 'normal', display: 'swap', weight: '700' }
    );
    await carMaxSharpSansDispBold.load();
    try {
      document.fonts.add(carMaxSharpSansDispBold);
    }
    catch { }

    let lato = new FontFace('Lato', 'url(https://www.carmax.com/shared/fonts/lato-v16-latin-regular.woff2)', {
      style: 'normal',
      display: 'swap',
      weight: '400',
    });
    await lato.load();
    try {
      document.fonts.add(lato);
    }
    catch { }

    let latoBold = new FontFace('Lato', 'url(https://www.carmax.com/shared/fonts/lato-v16-latin-700.woff2)', {
      style: 'normal',
      display: 'swap',
      weight: '700',
    });
    await latoBold.load();
    try {
      document.fonts.add(latoBold);
    }
    catch { }

    let firaCode = new FontFace('Fira Code', 'url(https://www.carmax.com/shared/fonts/FiraCode-v5-Regular.woff2)', {
      style: 'normal',
      display: 'swap',
      weight: '400',
    });
    await firaCode.load();
    try {
      document.fonts.add(firaCode);
    }
    catch { }

    let firaCodeBold = new FontFace('Fira Code', 'url(https://www.carmax.com/shared/fonts/FiraCode-v5-Bold.woff2)', {
      style: 'normal',
      display: 'swap',
      weight: '700',
    });
    await firaCodeBold.load();
    try {
      document.fonts.add(firaCodeBold);
    }
    catch { }

  });
}

